<template>
  <div class="loading d-flex justify-center align-center">
    <v-progress-circular
      class="center-loader"
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</template>

<style lang="scss">
.loading {
  min-height: calc(100vh - 153px);
  height: 100%;
}

.center-loader {
  position: absolute;
  top: calc(50% - 16px);
  left: calc(50% - 16px);
}
</style>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'CenterLoader',
})
</script>
